import axios from "axios";

const AxiosInstance = axios.create({
  baseURL: "/api/v1",
});

AxiosInstance.interceptors.request.use(function (config) {
  // trackPromise();
  let token = localStorage.getItem("token");
  config.headers["Authorization"] = "Bearer " + token;
  return config;
});

export default AxiosInstance;

// Plain axios without baseURL — for endpoints NOT under /api/v1
// (adsmarketing, careers, account_sponsorship, etc.)
export const plainAxios = axios.create({});
plainAxios.interceptors.request.use(function (config) {
  let token = localStorage.getItem("token");
  config.headers["Authorization"] = "Bearer " + token;
  return config;
});
